// extracted by mini-css-extract-plugin
export default {"loading":"LoadingSpinner_loading__kyMJi","spinner":"LoadingSpinner_spinner__va3O+","pulse":"LoadingSpinner_pulse__svS+o"};